import React from 'react';
import PropTypes from 'prop-types';

import IconBirdLogo from 'components/icons/iconBirdLogo';
import useScreen from 'hooks/useScreen';
import SliderStandard from './Slider';

const CustomerPhotosSlider = props => {
  const {
    imageArray,
    visibleSlides,
    navType,
    logo,
    imageWidth,
    imageHeight,
    title,
    description,
    updateImageArraySize,
    slideIndex,
  } = props;
  let finalVisibleSlides = visibleSlides
    ? visibleSlides.content
      ? visibleSlides.content
      : visibleSlides
    : 0;

  const { isMobileOrTablet } = useScreen();

  if (isMobileOrTablet) finalVisibleSlides = 1;

  return (
    <div>
      {title && (
        <div className="text-2xl text-gray font-bold flex flex-col-reverse mb-6 lg:mt-0 lg:mx-0 lg:mb-8 lg:flex-row lg:items-center">
          {title}
          {logo && (
            <div className="text-base text-gray mb-2 lg:mt-2 lg:mr-0 lg:mb-0 lg:ml-5 [&_svg]:scale-150 [&_svg]:mx-[.3rem] [&_svg]:my-0">
              <IconBirdLogo color="#27919C" /> {logo}
            </div>
          )}
        </div>
      )}
      {description && (
        <div className="text-base max-w-[500px] mb-12">{description}</div>
      )}
      <SliderStandard
        finalVisibleSlides={finalVisibleSlides}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        navType={navType}
        imageArray={imageArray}
        updateImageArraySize={updateImageArraySize}
        slideIndex={slideIndex}
      />
    </div>
  );
};

CustomerPhotosSlider.propTypes = {
  description: PropTypes.string,
  imageArray: PropTypes.array,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  logo: PropTypes.string,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  title: PropTypes.string,
  updateImageArraySize: PropTypes.func,
  visibleSlides: PropTypes.shape({
    content: PropTypes.number,
  }),
};

export default CustomerPhotosSlider;
